/* eslint-disable react/jsx-indent */
/* eslint-disable indent */
import React from 'react';
import { ChevronDownIcon, ChevronUpIcon } from '@chakra-ui/icons';
import { IconButton } from '@chakra-ui/react';
import AddInstanceModal from './add-instance-modal.component';

interface NonJsonNavigationButtonsProps {
  selectedQueryInstance: number;
  setSelectedQueryInstance: (value: number) => void;
  queryInstanceCount: number;
  debouncedSearchInstanceInput: string;
  sections: any[];
}

export const NonJsonNavigationButtons: React.FC<NonJsonNavigationButtonsProps> = ({
  selectedQueryInstance,
  setSelectedQueryInstance,
  queryInstanceCount,
  debouncedSearchInstanceInput,
  sections,
}) => (
  <>
    <IconButton
      aria-label="up"
      onClick={() => {
        setSelectedQueryInstance(selectedQueryInstance - 1);
        document
          .getElementById(`queryMatch${selectedQueryInstance - 1}`)
          ?.scrollIntoView();
      }}
      isDisabled={queryInstanceCount === 0 || selectedQueryInstance === 1}
      icon={<ChevronUpIcon fontSize="1.5rem" />}
    />
    <IconButton
      aria-label="down"
      isDisabled={selectedQueryInstance === queryInstanceCount}
      onClick={() => {
        setSelectedQueryInstance(selectedQueryInstance + 1);
        document
          .getElementById(`queryMatch${selectedQueryInstance + 1}`)
          ?.scrollIntoView();
      }}
      icon={<ChevronDownIcon fontSize="1.5rem" />}
    />
    <AddInstanceModal
      searchInstanceInput={debouncedSearchInstanceInput}
      selectedQueryInstance={selectedQueryInstance}
      sections={sections}
    />
  </>
);
